<template>
  <div id="CategoryIndex">
    <div style="padding: 10px">
      <van-form action="">
        <van-field
          v-model="keywords"
          type="search"
          @search="onSearch"
          placeholder="商品名称"
          clearable
          class="search"
        />
      </van-form>
    </div>
    <van-tabs v-model:active="tabActive">
      <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name">
        <GoodsLists :categoryId="item.id"></GoodsLists>
      </van-tab>
    </van-tabs>
    <CommonTabbar :tabbarActive="tabbarActive"></CommonTabbar>
  </div>
</template>

<script>
export default {
  name: 'CategoryIndex',
  data() {
    return {
      keywords: '',
      tabActive: 0,
      tabbarActive: 1,
      tabs: [
        { id: 1, name: '精选' },
        { id: 2, name: '电动工具' },
        { id: 3, name: '手动工具' },
        { id: 4, name: '液压工具' },
        { id: 5, name: '量刃具' },
        { id: 6, name: '低压电器' },
        { id: 7, name: '消防器材' },
        { id: 8, name: '电线电缆' },
        { id: 9, name: '劳保用品' },
        { id: 10, name: '灯具照明' },
        { id: 11, name: '涂料' },
        { id: 12, name: '卫浴洁具' },
        { id: 13, name: '紧固件' },
        { id: 14, name: '管道' },
        { id: 15, name: '胶粘' },
      ],
    }
  },
  methods: {
    onSearch() {
      this.$toast('您搜索的是：' + this.value)
    },
  },
}
</script>

<style lang="less" scoped>
.search {
  color: #333333;
  background-color: #e6e7e8;
  border-radius: 10px;
}
</style>